import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { common } from 'plato-js-client';
import moment from 'moment'
import { Button, Col, FormGroup, Label, Input, InputGroup, InputGroupAddon, Row, Spinner } from 'reactstrap';

function Address(props) {
  return ['line1', 'line2', 'line3', 'town', 'county', 'postcode'].filter(function(key) {
    return props.address[key];
  }).map(function(key) {
    return <React.Fragment key={ key }>{ props.address[key] }<br /></React.Fragment>;
  });
}

export function SubmitInvoiceWrapper(props) {
  return (
    <React.Fragment>
      <h1>Submit invoice</h1>
      <SubmitInvoice { ...props } />
    </React.Fragment>
  );
}

class InvoiceItem extends Component {
  render() {
    return (
      <React.Fragment>

        <FormGroup row>
          <Col sm={10}>{ this.props.description }</Col>
          <Col sm={2}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">£</InputGroupAddon>
              <Input type="number" defaultValue={ this.props.amount } innerRef={ el => this.amount = el } required />
            </InputGroup>
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label sm={3}>Additional Notes</Label>
          <Col sm={9}>
            <Input type="textarea" rows='2' innerRef={ el => this.description = el } />
          </Col>
        </FormGroup>
      </React.Fragment>
    );
  }
}

class SubmitInvoice extends Component {
  componentDidMount = () => {
    var booking = new common.Booking(this.props.match.params.bookingid);
    var bookingService = new common.BookingService(this.props.match.params.serviceid);
    bookingService.parent = booking;

    Promise.all([bookingService.get(), booking.get()]).then(() => {
      Promise.all([booking.property.details.get()]).then(() => {
        this.setState({ booking: booking, bookingService: bookingService })
      });
    }, (error) => this.setState({ error: error }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ saving: true, error: null });

    // Create the Invoice
    var invoice = new common.SupplierInvoice();
    invoice.invoicedate = moment().utc();
    invoice.invoicenumber = `Booking ${ this.state.booking.id }`;
    invoice.description = `Booking ${ this.state.booking.id } for ${ this.state.booking.property.name }`;
    this.props.workOrderSuppliers.forEach(function(workOrderSupplier) {
      invoice.workordersupplier = workOrderSupplier;
    });
    invoice.create().then(() => {
      // Create the InvoiceItem
      var invoiceItem = new common.SupplierInvoiceItem();
      invoiceItem.parent = invoice;
      invoiceItem.description = this.getDescription() + '\n\n' + this.item.description.value;
      invoiceItem.amountnet = this.item.amount.value;
      invoiceItem.amountvat = 0; //should this be hardcoded to 0?
      invoiceItem.exchangerate = {
        id: 1
      };
      invoiceItem.create().then(() => {
        this.props.history.push('/invoices');
      });
    }, (error) => this.setState({ saving: false, error: error }));
  }

  getDescription = () => {
    var date = moment(this.state.booking[this.state.bookingService.datetouse]).format('ddd D MMM YYYY');
    return `${ this.state.bookingService.service.name } services provided for ${ this.state.booking.property.name } on ${ date }`;
  }

  render() {
    if (this.state && this.state.error && !this.state.booking) {
      return <p>{ this.state.error.toString() }</p>;
    }

    if (!(this.state && this.state.booking)) {
      return (<div style={{width: "100%", display: 'flex', justifyContent: "center"}}>
              <Spinner style={{ width: '3rem', height: '3rem' ,  margin: "20px auto" }} color='secondary' />
            </div>);
    }

    for (var contactDetail of this.props.user.contactdetails.collection) {
      if (contactDetail.type === 'P') {
        var address = contactDetail.address;
        break;
      }
    }

    return (
      <React.Fragment>
        <Row>
          <Col sm={6}>
            <h4>Invoice from</h4>
            { this.props.user.toString() }
            <br />
            { address ? <Address address={ address } /> : <Link to='/account'>Please add your address</Link> }
          </Col>

          <Col sm={6}>
            <h4>Invoice to</h4>
            { this.state.booking.property.name }
            <br />
            <Address address={ this.state.booking.property.details.address } />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col sm={12}>
            <h4>Invoice ref</h4>
            Booking { this.state.booking.id }
          </Col>
        </Row>

        <Row className="mt-3">
          <Col sm={12}>
            <form onSubmit={ this.handleSubmit }>
              <InvoiceItem description={ this.getDescription() } amount={ this.state.bookingService.servicecharge.charge } ref={ el => this.item = el } />
              <p><Button type="submit" color="primary" disabled={ this.state.saving }>Submit invoice</Button></p>
              { this.state.saving && <p>Submitting invoice&hellip;</p> }
              { this.state.saved && <p>Changes saved!</p> }
              { this.state.error && <p>{ this.state.error.toString() }</p> }
            </form>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default SubmitInvoice;



// WEBPACK FOOTER //
// ./src/SubmitInvoice.js